const inputFields = [
  {
    name: "language",
    type: "dynamic_select",
    label: "Select Language",
    placeholder: "",
    options: [],
  },
  {
    name: "slug",
    type: "select",
    label: "Path",
    placeholder: "",
    options: [
      {
        value: "terms-conditions",
        label: "Terms & Conditions",
      },
      {
        value: "privacy-policy",
        label: "Privacy Policy",
      },
      {
        value: "anti-sex-trafficking-policy",
        label: "Anti Sex Trafficking Policy",
      },
    ],
  },
  {
    name: "title",
    type: "text ",
    label: "Title",
  },
  {
    name: "content",
    type: "ckeditor",
    label: "Content",
    placeholder: "",
  },
];

export default inputFields;
